var angular = require("angular");
var app = angular.module("learn-directives");
import React from "react";
import { createRoot } from "react-dom/client";
import AutoSizer from "react-virtualized-auto-sizer";
import {Pie} from "@nivo/pie";

function formatData(data, noAnswerKey) {
    const choiceResults = {}
    let total = 0
    const addAnswer = (answer) => {
        if (answer) {
            choiceResults[answer] += 1;
        } else {
            choiceResults[noAnswerKey] = choiceResults[noAnswerKey] && choiceResults[noAnswerKey] + 1 || 1;
        }
        total++;
    }

    const formatLegend = (answer) => {
      const words = answer.split(' ');
      if (words.length <= 10) {
        return answer;
      }
      let wordList = [];
      for (let i = 0; i <= words.length; i++) {
        wordList.push(words[i]);
        // Stops answer after first 10 words
        if (i === 10) {
          break;
        }
      }
      return wordList.join(' ') + '...';
    }

    for (const choice of data.choices) {
        choiceResults[choice] = 0
    }
    switch (data.type){
        case 'checkbox':
            for (const answer of data.answers) {
                for (const innerAnswer of answer) {
                    addAnswer(innerAnswer)
                }
            }
            break;
        case 'radiogroup':
            for (const answer of data.answers) {
                addAnswer(answer)
            }
            break;
        default:
            return;
    };
    let dataOBj = Object.entries(choiceResults).map(([key, value]) => {
      const formattedAnswer = formatLegend(key);
        return {
            answer: key,
            count: value,
            label: `${formattedAnswer} (${value})`
        };
    });
    return {data: dataOBj, totalCount: total}
}

function SurveyMultiChoiceQuestionChart(props) {
    const formattedData = formatData(props.data, props.translations['hostSurveys.noAnswer']);
    return (
        <div className="chart-box-autosizer-wrapper">
            <AutoSizer>
                {({ width, height }) => (
                    <Pie
                        data={formattedData.data}
                        id={'answer'}
                        value={'count'}
                        width={width}
                        height={height}
                        margin={{ top: 40, bottom: 20 }}
                        innerRadius={0.5}
                        padAngle={0.7}
                        cornerRadius={3}
                        activeOuterRadiusOffset={8}
                        borderWidth={1}
                        borderColor={{
                            from: 'color',
                            modifiers: [['darker', 0.2]],
                        }}
                        colors={{ scheme: 'paired' }}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor="#333333"
                        arcLinkLabelsThickness={2}
                        arcLinkLabelsColor={{ from: 'color' }} arcLabel={(d) =>
                            `${(d.value / formattedData.totalCount).toLocaleString(undefined, {
                                style: 'percent',
                                minimumFractionDigits: 0,
                            })}`
                        }
                        arcLabelsSkipAngle={10}
                        arcLabelsTextColor={{
                            from: 'color',
                            modifiers: [['darker', 2]],
                        }}
                        tooltip={({ datum: { id, value, color } }) => (
                            <div
                                style={{
                                    padding: 7,
                                    borderRadius: 5,
                                    color: '#000000',
                                    background: '#FFFFFF',
                                    boxShadow: '0px 0px 1px black'
                                }}
                            >
                                {value} Users Chose '{id}'
                            </div>
                        )}
                        legends={[
                            {
                                anchor: 'left',
                                direction: 'column',
                                justify: false,
                                translateX: 0,
                                translateY: 0,
                                itemsSpacing: 10,
                                itemWidth: 100,
                                itemHeight: 18,
                                itemTextColor: '#999',
                                itemDirection: 'left-to-right',
                                itemOpacity: 1,
                                symbolSize: 18,
                                symbolShape: 'circle',
                                toggleSerie: true,
                                effects: [
                                    {
                                        on: 'hover',
                                        style: {
                                            itemTextColor: '#000',
                                        },
                                    },
                                ],
                            },
                        ]}
                    />
                )}
            </AutoSizer>
        </div>
    )
}

function Layout(props) {
    const barCharts = Object.values(props.questionResults).map((question, key) => {
        const textTypeQuestion = question.type === 'comment' || question.type === 'text';
        return (
            <div key={key} style={{padding: "1rem 0", borderBottom: "1px solid hsla(0, 0%, 0%, 0.2)"}}>
                {
                    textTypeQuestion ?
                        <div>
                            <h3>{question.title}</h3>
                            <div className={"chart-row"}>
                                <label className={'ng-binding'}>These results cannot be aggregated. Please view text submissions in the submissions page.</label>
                            </div>
                        </div>
                        :
                        <div>
                            <h3>{question.title}</h3>
                            <div className={"chart-row"}>
                                <div className={"chart-container"} style={{height: "300px", flex: 1}}>
                                    <SurveyMultiChoiceQuestionChart data={question} translations={props.translations} />
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    });

    return (
        <div>
            <style type="text/css">{`
      .chart-row {
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
      .chart-container {
        border: 0px;
        border-bottom: 1px gray;
        border-radius: 5px;
        padding: 10px 0 10px 0 ;
      }
      `}</style>
            {barCharts}
        </div>
    );
}


function renderLayout(root, translations, questionResults) {
    root.render(
        <Layout
            questionResults={questionResults}
            translations={translations}
        />
    );
}

const reactDirective = app.directive("hostSurveyChart", ['$translate',
    function ($translate) {
        return {
            template: '<div id="host-survey-chart-app" class="react-part">Charts</div>',
            scope: {
                questionResults: "=",
                translations: "=",
            },
            link: function (scope) {
                $translate(['hostSurveys.noAnswer']).then(function(translations) {
                    const reactapp = document.getElementById("host-survey-chart-app");
                    const root = createRoot(reactapp);
                    scope.$watch(
                        'questionResults',
                        function(newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                renderLayout(root, translations, scope.questionResults)
                            }
                        },
                        true
                    );
                });
            },
        };
    },
]);

export default reactDirective;